import React from 'react';
import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';

const { Title, Paragraph } = Typography;

const TermsOfUse = () => {
  const { t } = useTranslation();

  const formatText = (text) => {
    const elements = [];
    const regex =
      /(BRRM DOO|office@brrm\.eu|\+?\d[\d\s\-]{7,})/gi;
    let lastIndex = 0;
    let match;

    while ((match = regex.exec(text)) !== null) {
      if (match.index > lastIndex) {
        elements.push(text.slice(lastIndex, match.index));
      }

      const value = match[0];
      if (value.toLowerCase() === 'office@brrm.eu') {
        elements.push(
          <a
            href={`mailto:${value}`}
            key={value}
            style={{ fontWeight: 500, color: 'black' }}
          >
            {value}
          </a>
        );
      } else if (/^\+?\d[\d\s\-]{7,}$/.test(value)) {
        elements.push(
          <a
            href={`tel:${value.replace(/\s+/g, '')}`}
            key={value}
            style={{ fontWeight: 500, color: 'black' }}
          >
            {value}
          </a>
        );
      } else {
        elements.push(<strong key={value}>{value}</strong>);
      }

      lastIndex = regex.lastIndex;
    }

    if (lastIndex < text.length) {
      elements.push(text.slice(lastIndex));
    }

    return elements;
  };

  const sections = t('terms.sections', { returnObjects: true });

  return (
    <div style={{ maxWidth: 900, margin: '0 auto', padding: '24px' }}>
      <Title level={2} style={{ textAlign: 'center', marginBottom: '50px' }}>
        {t('terms.title1')}
        <br />
        {t('terms.title2')}
      </Title>

      {sections.map((section, i) => (
        <React.Fragment key={i}>
          <Title level={4}>{section.title}</Title>

          {section.paragraphs &&
            section.paragraphs.map((p, idx) => (
              <Paragraph key={idx}>{formatText(p)}</Paragraph>
            ))}

          {section.list && (
            <ul>
              {section.list.map((item, idx) => (
                <li key={idx}>{formatText(item)}</li>
              ))}
            </ul>
          )}

          {section.paragraphs2 &&
            section.paragraphs2.map((p, idx) => (
              <Paragraph key={idx}>{formatText(p)}</Paragraph>
            ))}
        </React.Fragment>
      ))}
    </div>
  );
};

export default TermsOfUse;
